import React from 'react';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import { StyledLabel } from './RadioContainer.style';
import { colorPalette } from '../../colorPalette';
import { useRadioGroup } from '@mui/material/RadioGroup';
export const RadioContainer = ({ heading, description, name, value, margins }) => {
    const radioGroup = useRadioGroup();
    let checked = false;
    if (radioGroup) {
        checked = radioGroup.value === value;
    }
    return (React.createElement(StyledLabel, { component: "label", margins: margins, checked: checked, "data-qa": "radio-container" },
        React.createElement(Radio, { name: name, value: value }),
        React.createElement(Box, { marginLeft: "3px" },
            React.createElement(Typography, { color: colorPalette.gray900, fontWeight: 600, lineHeight: "18px" }, heading),
            React.createElement(Typography, { color: colorPalette.gray800, lineHeight: "18px", marginTop: "4px" }, description))));
};
